module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deal-wizard/deal-approval/signature-dialog/signature-dialog.component.css
// module id = ./src/app/components/deal-wizard/deal-approval/signature-dialog/signature-dialog.component.css
// module chunks = main